<div class="page-layout blank flex flex-col">
  <particle-workflow-wizard [workflowId]="workflowId"
                            [apiEndpointKey]="apiEndpointKey"
                            (GridCellValueChanged)="onGridCellValueChange($event)">

  </particle-workflow-wizard>
</div>

